import React from 'react';
import TableBox from '../../../../components/TableBox';
import { TableContextProvider } from '../../../../interfaces/common';

interface HeaderMappingTabProps {
  tableValues: TableContextProvider;
}

const HeaderMappingTab: React.FC<HeaderMappingTabProps> = ({ tableValues }) => {
  return (
    <div className="card-body">
      <TableBox tableValues={tableValues} />
    </div>
  );
};

export default HeaderMappingTab;

